import { gql } from "@apollo/client";
export const InstalledBaseNodeList = gql`
    query InstalledBaseNodeList($search: SearchInput, $filter: InstalledBaseNodeListFilter!, $pagination: Pagination, $sort: InstalledBaseNodeListSort) {
        installedBaseNodeList(filter: $filter, search: $search) {
            total
            installedBaseNodes (pagination: $pagination, sort: $sort) {
                id
                key
                title
                isStarred
                assetCount
                childrenNodeCount
                access {
                    id
                    read
                    write
                    delete
                }
                nodeType {
                    id
                    key
                    name
                }
                parentNode {
                    key
                    id
                    title
                    nodeType {
                        id
                        key
                        name
                    }
                }
                assetLocation {
                    id
                    isInstalled
                    iotConnection {
                        id
                        connectionStatus
                    }
                    asset {
                        id
                        serialNumber
                    }
                }
                keyPath
                system {
                    id
                    systemType
                }
            }
        }
    }
`;
